import handler from 'api/handler'

const prefix = '/admin/jobs'

const methods = {
  create: args => handler({ method: 'post', url: `${prefix}/create`, args }),
  updateJobApprovalStatus: args => handler({ method: 'put', url: `${prefix}/updateJobApprovalStatus`, args }),
  fetchNewJobOpenings: args => handler({ method: 'get', url: `${prefix}/fetchNewJobOpenings`, args }),
}

export default methods
